module.exports = __webpack_public_path__ + "img/4.daafd016.png";